import {
  ref, getCurrentInstance, watchEffect, type Ref,
} from 'vue';

type EditorData = Record<string, unknown>;
type EditorCallback = (data: EditorData) => void;

const useEditor = (cb: EditorCallback = () => {}): { editorData: Ref<EditorData> } => {
  const currentInstance = getCurrentInstance();

  if (!currentInstance) {
    throw new Error('useEditor must be called within a component setup function');
  }

  const { globalProperties } = currentInstance.appContext.config;

  const editorData = ref<EditorData>({});

  // Инициализируем начальное значение, если оно уже есть
  const editorDataRef = (globalProperties as { $editorData?: Ref<EditorData> })?.$editorData;
  if (editorDataRef?.value) {
    const initialData = editorDataRef.value;
    editorData.value = initialData;
    if (Object.keys(initialData).length > 0) {
      cb(initialData);
    }
  }

  watchEffect(() => {
    const updatedEditorData = editorDataRef?.value;
    if (updatedEditorData) {
      // Проверяем, изменились ли данные, чтобы избежать лишних вызовов
      const dataString = JSON.stringify(updatedEditorData);
      const currentDataString = JSON.stringify(editorData.value);
      if (dataString !== currentDataString) {
        editorData.value = updatedEditorData;
        cb(updatedEditorData);
      }
    }
  });

  return {
    editorData,
  };
};

export { useEditor };
